import React from 'react';
interface RouterContextValue {
  unauthorizedRedirectTo?: string;
}

export const RouterContext = React.createContext<RouterContextValue>({});
